import { apiFetch } from "../client"

export interface AdminNotificationRow {
  notificationId: string
  eventType: string | null
  notificationKey: string | null
  alertKey: string | null
  title: string
  body: string
  resourceType: string | null
  resourceId: string | null
  isRead: boolean
  createdAt: string
}

export interface AdminNotificationsResponse {
  data: AdminNotificationRow[]
  meta: {
    page: number
    totalPages: number
    total: number
  }
}

export interface AdminUnreadCountResponse {
  data: {
    unreadCount: number
  }
}

export async function listNotifications(params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : ""
  return apiFetch<AdminNotificationsResponse>(`/notifications${query}`)
}

export async function getUnreadCount() {
  return apiFetch<AdminUnreadCountResponse>("/notifications/unread-count")
}

export async function markNotificationsRead(notificationIds: string[]) {
  return apiFetch<{ data: { updatedCount: number } }>("/notifications/mark-read", {
    method: "POST",
    rawBody: { notificationIds },
  })
}

export async function markAllNotificationsRead() {
  return apiFetch<{ data: { updatedCount: number } }>("/notifications/mark-all-read", {
    method: "POST",
  })
}
